import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const RefundPolicyPage = lazy(() => import('../pages/refund-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/service/:serviceId',
    element: <ServiceDetailPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/refund-policy',
    element: <RefundPolicyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
